import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LoaderProvider } from "./contexts/LoaderContext.js";
import Header from "./components/Header.js";
import Footer from "./components/Footer.jsx";
import Loader from "./components/Loader.js";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import { ZButton } from "./components/ZButton.jsx";
import Page from "./pages/Page.jsx";

// Lazy-loaded components
const Contact = lazy(() => import("./pages/Contact.jsx"));
const Home = lazy(() => import("./pages/Home.jsx"));
const Blog = lazy(() => import("./pages/Blog.jsx"));
const NewBlog = lazy(() => import("./pages/NewBlog.jsx"));
const BlogDetail = lazy(() => import("./pages/BlogDetail.jsx"));
const FeaturesPage = lazy(() => import("./pages/Features.jsx"));
const FeatureDetails = lazy(() => import("./pages/FeatureDetails.jsx"));
const CaseStudiesPage = lazy(() => import("./pages/CaseStudies.jsx"));
const CaseStudyDetail = lazy(() => import("./pages/CaseStudyDetail.jsx"));
const GamesPage = lazy(() => import("./pages/Games.jsx"));
const Testimonials = lazy(() => import("./components/TestimonialCard.jsx"));
const TestimonialDetail = lazy(() => import("./pages/TestimonialDetail.jsx"));
const NotFound = lazy(() => import("./pages/NotFound.jsx"));
const EventsPage = lazy(() => import("./pages/EventsPage.jsx"));

function App() {
  console.log(`App is running in ${process.env.NODE_ENV} mode`);
  return (
    <HelmetProvider>
      <LoaderProvider>
        <Router>
          <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-grow">
              <ErrorBoundary>
                <Suspense fallback={<Loader />}>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/page/:id" element={<Page />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/new-blog" element={<NewBlog />} />
                    <Route path="/blog/:id" element={<BlogDetail />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/features" element={<FeaturesPage />} />
                    <Route path="/feature/:featureId" element={<FeatureDetails />} />
                    <Route path="/games" element={<GamesPage />} />
                    <Route path="/case-studies" element={<CaseStudiesPage />} />
                    <Route path="/case-study/:id" element={<CaseStudyDetail />} />
                    <Route path="/testimonials" element={<Testimonials />} />
                    <Route
                      path="/testimonial/:id"
                      element={<TestimonialDetail />}
                    />
                    <Route path="/events" element={<EventsPage />} />
                    <Route path="/404" element={<NotFound />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Suspense>
              </ErrorBoundary>
            </main>
            <Suspense fallback={<Loader />}>
              <Footer />
            </Suspense>
            <ZButton />
          </div>
        </Router>
      </LoaderProvider>
    </HelmetProvider>
  );
}

export default App;
